module.exports = __webpack_public_path__ + "img/programLogo.a179d01d.png";